import { faLink } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import {
    ListarEtapasController,
    ListarEtapasPorCategoriaAtendimentoETipoCasoController,
} from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarCategoriasAtendimentosController } from "../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { EditarStatusEtapaController } from "../../../../Controllers/Geral/StatusEtapa/StatusEtapaController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IListaStatusEtapa } from "../../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import { ACESSOS } from "../../../../Routes/Acessos";
import { CriarStatusPorTipoCasoService } from "../../../../Services/Geral/StatusEtapa/StatusEtapaServices";

interface ICriarStatusEtapaProps {
    idTipoCaso: number;
    idCategoria: number;
    row?: IListaStatusEtapa;
    editando?: boolean;
    updateList: () => void;
    setShow: Dispatch<SetStateAction<boolean>>;
}

interface IFormData {
    DS_STATUS_ETAPA: string;
    ID_ETAPA_TIPO_CASO: number;
    FL_OBRIGATORIO: boolean;
    ID_CATEGORIA_ATENDIMENTO: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number;
}

export default function CriarStatusEtapa(props: ICriarStatusEtapaProps) {
    const FormMethods = useForm();

    const [idCategoria, setIdCategoria] = useState(props.idCategoria);

    const { value: lstEtapas } = useAsyncEffect(
        () =>
            ListarEtapasPorCategoriaAtendimentoETipoCasoController(
                0,
                props.idTipoCaso
            ),
        [props.idTipoCaso]
    );

    const { execute: listarCategoriaAtendimentos } = useAsyncCallback(
        () => ListarCategoriasAtendimentosController(props.idTipoCaso),
        []
    );

    const { value: etapas, loading: etapasLoading } = useAsyncEffect(
        () => ListarEtapasController(props.idTipoCaso, idCategoria),
        [props.idTipoCaso, idCategoria]
    );

    const { execute: inserirStatusEtapa, loading: inserirStatusEtapaLoading } =
        useAsyncCallback(CriarStatusPorTipoCasoService, []);

    const { execute: EditarStatusEtapa, loading: EditarStatusEtapaLoading } =
        useAsyncCallback(EditarStatusEtapaController, []);

    function handleCriarStatusEtapa(formData: IFormData) {
        if (!props.editando) {
            inserirStatusEtapa({
                DS_STATUS_ETAPA: formData.DS_STATUS_ETAPA,
                FL_OBRIGATORIO: formData.FL_OBRIGATORIO,
                ID_CATEGORIA_ATENDIMENTO: formData.ID_CATEGORIA_ATENDIMENTO,
                ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                    formData.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                ID_ETAPA_TIPO_CASO: formData.ID_ETAPA_TIPO_CASO,
            }).then((res) => {
                props.updateList();
                props.setShow(false);
            });
        } else {
            EditarStatusEtapa({
                DS_STATUS_ETAPA: formData.DS_STATUS_ETAPA,
                FL_OBRIGATORIO: formData.FL_OBRIGATORIO,
                ID_CATEGORIA_ATENDIMENTO: formData.ID_CATEGORIA_ATENDIMENTO,
                ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                    formData.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                ID_ETAPA_TIPO_CASO: formData.ID_ETAPA_TIPO_CASO,
                ID_STATUS_ETAPA: props.row?.ID_STATUS_ETAPA,
            }).then((res) => {
                props.updateList();
                props.setShow(false);
            });
        }
    }

    return (
        <UnForm handleSubmit={handleCriarStatusEtapa}>
            <div className="col-12 d-flex justify-content-center align-items-center flex-column">
                <UnForm.Input
                    type="text"
                    wrapperClassName="col-12 p-0 mb-2"
                    name="DS_STATUS_ETAPA"
                    label="Descrição"
                    registerOptions={{
                        required: "Insira a descrição do atendimento",
                    }}
                    defaultValue={props.row?.DS_STATUS_ETAPA}
                />

                {ACESSOS.ATENDIMENTO.ID_MODULO === props.idTipoCaso ||
                ACESSOS.REPASSE.ID_MODULO === props.idTipoCaso ||
                ACESSOS.COBRANCA.ID_MODULO === props.idTipoCaso ? (
                    <>
                        <UnForm.LazySelect
                            label="Categoria de Atendimento"
                            name="ID_CATEGORIA_ATENDIMENTO"
                            wrapperClassName="col-12 p-0 mb-2"
                            registerOptions={{
                                valueAsNumber: true,
                                required: "Selecione uma categoria",
                            }}
                            {...FormMethods}
                            onChange={(e) =>
                                setIdCategoria(Number(e.target.value))
                            }
                            controller={listarCategoriaAtendimentos}
                            getDS={(s) => s.DS_CATEGORIA_ATENDIMENTO}
                            getKeyValue={(s) => s.ID_CATEGORIA_ATENDIMENTO}
                            defaultValue={props.row?.ID_CATEGORIA_ATENDIMENTO}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                        <OrSpinner spinner="capys" loading={etapasLoading}>
                            <UnForm.Select
                                label="Etapa"
                                wrapperClassName="col-12 p-0 mb-2"
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                defaultValue={
                                    props.row
                                        ?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                            >
                                <option></option>
                                {etapas?.map((etapa) => (
                                    <option
                                        value={
                                            etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                ? etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                : etapa.ID_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    >
                                        {
                                            etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                    </option>
                                ))}
                            </UnForm.Select>
                        </OrSpinner>
                    </>
                ) : (
                    <UnForm.Select
                        label="Etapa"
                        name="ID_ETAPA_TIPO_CASO"
                        wrapperClassName="col-12 p-0 mb-2"
                        registerOptions={{
                            required: "Selecione uma etapa",
                        }}
                        defaultValue={props.row?.ID_ETAPA_TIPO_CASO}
                    >
                        <option defaultValue={props.row?.ID_ETAPA_TIPO_CASO}>
                            {props.row?.DS_ETAPA_TIPO_CASO}
                        </option>
                        {lstEtapas?.map((etapa) => (
                            <option value={etapa.ID_ETAPA_TIPO_CASO}>
                                {etapa.DS_ETAPA}
                            </option>
                        ))}
                    </UnForm.Select>
                )}

                <UnForm.Switch
                    wrapperClassName="col-12 col-lg-4"
                    color="primary"
                    label="Obrigatorio?"
                    labelPosition="top"
                    type="checkbox"
                    name="FL_OBRIGATORIO"
                    defaultChecked={props.row?.FL_OBRIGATORIO}
                />
                <UnForm.SubmitButton
                    color="success"
                    wrapperClassName="w-100 mt-8"
                    className="w-100"
                    icon={faLink}
                    loading={
                        inserirStatusEtapaLoading || EditarStatusEtapaLoading
                    }
                    disabled={
                        inserirStatusEtapaLoading || EditarStatusEtapaLoading
                    }
                    loadingSize={"sm"}
                >
                    {props.editando
                        ? "Editar Status Etapa"
                        : "Criar Status Etapa"}
                </UnForm.SubmitButton>
            </div>
        </UnForm>
    );
}
